const formatDuration = (duration: number) => {
  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration % 3600) / 60);
  const seconds = Math.round(duration % 60);

  const paddedMinutes = minutes.toString().padStart(2, "0");
  const paddedSeconds = seconds.toString().padStart(2, "0");

  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  }

  if (minutes >= 10) {
    return `${minutes}m`;
  }

  return `${paddedMinutes}:${paddedSeconds}`;
};

export default formatDuration;
